// extracted by mini-css-extract-plugin
export default {"label":"b3lVJ0","text":"c3lVJ0","fullWidth":"d3lVJ0","icon":"e3lVJ0","open":"f3lVJ0","button":"g3lVJ0","ghost":"h3lVJ0","tertiary":"i3lVJ0"};